<form (ngSubmit)="onSubmit()">
  <h2 matDialogTitle>{{ title }}</h2>
  <mat-dialog-content>{{ content }}</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" color="secondary" matDialogClose>{{ cancelText }}</button>
    <button mat-button type="submit" color="primary">{{ confirmText }}</button>
  </mat-dialog-actions>
</form>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/confirmation-dialog/confirmation-dialog.component.html